<template>
  <div id="registerpremiumcodecard" :class="getClassCard" class="inversecolor">
    <div style="text-align:center">
      <!-- <span class="icon" style="font-size:2rem">
        <i class="mdi mdi-gift"></i>
      </span>  -->
      <img src="@/assets/imgs/badge_photo.svg" style="width:90px" />
    </div>
    <p style="font-size: 20px; text-align: center; ">
      introduce tu código premium
    </p>

    <b-field>
      <b-input
        type="text"
        class="premiumcodeform onlyline"
        value=""
        v-on:blur="autovalidate"
        v-model="code"
        @keydown.native.enter="handleKey"
        ref="codeinput"
        expanded
      >
      </b-input>
    </b-field>
  </div>
</template>
<script>
export default {
  
  props: {
    validateOnBlur: {
      type: Boolean,
      default: false
    },
    validateWithAuth: {
      type: Boolean,
      default: false
    },
    previousPremiumCode: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: 'Introduce código válido, o continúa sin código'
    }
  },
  data: () => ({
    code: '',
    showErrorPremium: false,
    errorPremiumMsg: ''
  }),
  methods: {
    handleKey(event) {
      if (event.keyCode === 13) {
        //document.getElementById("register-step0").focus();
        this.$refs.codeinput.$el.firstElementChild.blur()
        event.preventDefault()
        //  this.validate()
      }
    },
    autovalidate() {
      if (this.validateOnBlur == true) this.validate()
    },
    validate() {
      this.$store.commit('register/cleanCredentials')
      if (this.validateWithAuth) {
        this.$emit('validationStarted')
        this.$store
          .dispatch('register/validatePremiumCodeAuth', this.code)
          .finally(() => {
            this.showErrorPremium = true
            //if(this.$store.state.register.validPremiumCode==false)
            //this.errorPremiumMsg="Introduce código válido, o continúa sin código"
            this.$emit('validationFinished')
          })
      } else {
        this.$emit('validationStarted')
        this.$store
          .dispatch('register/validatePremiumCode', this.code)
          .finally(() => {
            this.showErrorPremium = true
            //if(this.$store.state.register.validPremiumCode==false)
            //this.errorPremiumMsg="Introduce código válido, o continúa sin código"
            this.$emit('validationFinished')
          })
      }
    }
  },
  computed: {
    isValidCode() {
      return this.$store.state.register.validPremiumCode
    },
    getClassCard() {
      if (this.showErrorPremium == false) return ''
      else if (
        this.showErrorPremium == true &&
        this.$store.state.register.validPremiumCode == false
      )
        return 'is-danger'
      else if (
        this.showErrorPremium == true &&
        this.$store.state.register.validPremiumCode == true
      )
        return 'is-success'
      else return ''
    }
  },
  created() {
    this.code = this.previousPremiumCode
    if (this.previousPremiumCode) {
      this.autovalidate()
    }
  }
}
</script>
<style lang="less">
//@import (reference) '../../assets/styles/main.less';

#registerpremiumcodecard {
  margin-top: 2em;
  background: linear-gradient(114.9deg, #247ba0 2.27%, #2fa0d0 108.76%);
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 8px;
  padding: 15px 15px;
  color: #fff;
  &.is-success {
    background: linear-gradient(114.9deg, #70c1b3 2.27%, #8de4d5 108.76%);
  }
  &.is-danger {
    background: linear-gradient(115.5deg, #ed6a5a 2.28%, #e29c94 116.9%);
  }
  div.premiumcodeform {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
  }

  div.premiumcodeform > input.input {
    background-color: transparent !important;
    border: none;
    border-bottom: 1px white dashed;
    color: white;
    text-align: center;
    text-transform: uppercase;
    max-width: 12em;
  }
}
</style>
